<div class="flex items-center justify-center min-h-[100dvh] login">
  <div class=" login-wrapper">
    <p-card class="login-card">
      <ng-template #header>
        <div class="bg-black text-white p-6 rounded-t-xl">
          <img [src]="'assets/img/logo.png'" class="ml-3 mr-3" style="height: 30px">
        </div>
      </ng-template>
      <form class="ml-3 mr-3" [formGroup]="loginForm" (ngSubmit)="login()">
        <div class="login-title " [innerHTML]="'title.tournament-spectacular' | translate">
        </div>
        <div class="mt-5 ">
          <input pInputText type="text" class="login-input w-full" [placeholder]="'field.user' | translate" formControlName="username"/>
        </div>
        <div class="mt-5">
          <p-password  [feedback]="false"  [toggleMask]="true" class="login-input w-full" [placeholder]="'field.password' | translate" formControlName="password"/>
        </div>
        <div class=" mt-8 ">
          <p-button type="submit" styleClass="w-full bg-black border-black" [label]="'button.login' | translate" />
        </div>
        <div class="text-center text-sm text-gray-500 mt-5">
          {{ 'forgotten-password' | translate }}
        </div>
      </form>
    </p-card>
  </div>
</div>
